
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class CompanyGrid extends Serenity.EntityGrid<CompanyRow, any> {
        protected getColumnsKey() { return 'OMS.Company'; }
        protected getDialogType() { return CompanyDialog; }
        protected getIdProperty() { return CompanyRow.idProperty; }
        protected getLocalTextPrefix() { return CompanyRow.localTextPrefix; }
        protected getService() { return CompanyService.baseUrl; }
        protected getInsertPermission() { return CompanyRow.insertPermission; }
        protected getUpdatePermission() { return CompanyRow.updatePermission; }
        protected getDeletePermission() { return CompanyRow.deletePermission; }
        protected useViewMode() { return true; }


        constructor(container: JQuery) {
            super(container);
        }
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        updateInterface() {
            super.updateInterface();

            if (!this.hasInsertPermission || this.readOnly) {
                this.toolbar.findButton('add-button').toggle(this.updateDisabledState());
            }
        }
    }
}